module.exports = __webpack_public_path__ + "static/media/purple.205b98a1.png";